import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-active-deactiv-customer',
  templateUrl: './active-deactiv-customer.component.html',
  styleUrls: ['./active-deactiv-customer.component.css']
})
export class ActiveDeactivCustomerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
